import API from './API'
const route = 'message/'
const driverList = 'driver/'
const push = 'push'

var Message = (function () {
  function message() {}

  message.prototype.create = function (data) {
    return API.post(route, data)
  }

  message.prototype.getList = function () {
    return API.get(`${route}list`)
  }

  message.prototype.remove = function (id) {
    return API.delete(`${route}${id}`)
  }

  message.prototype.get = function (id) {
    return API.get(`${route}${id}`)
  }

  message.prototype.getDriverList = function (id) {
    return API.get(`${route}${id}`)
  }

  message.prototype.pushDriverMessage = function (data, query) {
    return API.post(route + push + `/?task=${query}`, data)
  }

  return message
})()
export default Message



// WEBPACK FOOTER //
// ./src/assets/js/libs/Message.js